// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/css/common.css
// module id = 1099
// module chunks = 42